<template>
  <div
    class="TheHeader"
  >
    <div class="topbar">
      <LanguageSwitcher />

      <div class="logo">
        <router-link to="/">
          <img
            src="@/assets/images/logo.svg"
            alt=""
            width="200"
          >
        </router-link>
      </div>

      <div class="user">
        <div
          v-if="logged"
          class="user"
        >
          <img
            :src="loadImageServer(userImage())"
            alt=""
          >
          <button
            class="register"
            @click="userId"
          >
            {{ $t('HEADER.DISCIPLINES') }}
          </button>

          <button
            class="login"
            @click="logout"
          >
            {{ $t('HEADER.LOGOUT') }}
          </button>
        </div>

        <div v-else>
          <button
            class="register"
            @click="$router.push({ name: 'Form'})"
          >
            {{ $t('HEADER.SIGNUP') }}
          </button>

          <button
            class="login"
            @click="showModal"
          >
            {{ $t('HEADER.LOGIN') }}
          </button>
        </div>
      </div>
    </div>
    <div class="header">
      <h1>{{ $t('HEADER.TITLE') }}</h1>

      <p
        class="description"
        @click="showModal2"
        v-html="$t('HEADER.DESCRIPTION')"
      />

      <!-- <p class="description">
        {{ $t('HEADER.DESCRIPTION1') }}
      </p>
      <p class="second-row">
        {{ $t('HEADER.DESCRIPTION2') }} <a
          href="#"
          class="requirements"
          @click="showModal2"
        >{{ $t('HEADER.DESCRIPTION3') }}</a>.
      </p> -->
    </div>

    <transition name="fade">
      <Login
        v-if="isOpen"
        @close="isOpen = false"
      />
    </transition>
    <transition name="fade">
      <Requirements
        v-if="isOpen2"
        @close="isOpen2 = false"
      />
    </transition>
  </div>
</template>

<script>

import LanguageSwitcher from '@/components/LanguageSwitcher';
import Login from '@/components/Login';
import Requirements from '@/components/Requirements';
import { get } from 'vuex-pathify';
// import { USER_TOKEN_KEY } from '@/store/authModule';

export default {

  components: { LanguageSwitcher, Login, Requirements },

  props: {
    logged: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      isOpen2: false,
      author: undefined,
      id: undefined,
      image: undefined,
    };
  },

  computed: {
    ...get('authModule', ['getLogin', 'getUser']),

  },

  // async created() {
  //   // calls to store action
  //   if (this.logged) {
  //     this.author = this.getAuthor();
  //     this.id = this.author.id;
  //   }
  // },

  methods: {
    showModal() {
      this.isOpen = true;
    },
    showModal2() {
      this.isOpen2 = true;
    },
    /*
    checkIfIsLogged() {
      const token = this.getLogin();
      if (this.getLogin() !== undefined) {
        return true;
      }
      return false;
    },
*/
    userId() {
      if (this.logged) {
        this.author = this.getUser();
        this.id = this.author.id;
        this.$router.push(`/author/${this.id}`);
      }
    },

    userImage() {
      if (this.logged) {
        this.author = this.getUser();
        this.image = this.author.imagen;
      }
      return this.image;
    },

    loadImageServer(image) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/images/${image}`;
    },

    async logout() {
      await this.$store.dispatch('authModule/logout');
    },
  },
};
</script>

<style scoped lang="scss">
.TheHeader {
  background-color: transparent;
  @media #{$breakpoint-md-max} {
        font-size: $font-size-s;
  }
  .topbar {
    display: flex;
    align-items: flex-start;
    padding-top: 1rem;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 1440px;
    z-index: 1;

    .logo {
      margin: 0 2rem;
      flex: 0 1 160px;
      img {
        width: 100%;
      }
    }
    .user {
      margin-left: auto;
      display: flex;
      align-items: center;
      img {
        width: 50px;
        flex: 0 0 50px;
        border-radius: 50%;
      }
      button {
        background-color: transparent;
        border: none;
        color: white;
        margin: 0 0.5rem;
        cursor: pointer;
        white-space: nowrap;
        &.login {
          color: var(--color-primary);
        }
      }
    }
  }
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: url('~@/assets/images/f_header.jpg') center;
    background-color: transparent;
    background-size: cover;
    height: 210px;
    position: relative;
    color: white;
    @media #{$breakpoint-lg-max} {
      height: auto;
    }
    h1 {
      font-size: 2rem;
      margin-top: 4rem;
      @media #{$breakpoint-lg-max} {
        margin-top: 7rem;
      }
    }
    .description {
      margin-top: 3rem;
      text-align: center;
      @media #{$breakpoint-lg-max} {
        margin: 2rem;
      }
    }
    // .second-row{
    //   margin-top: 5px;
    //   @media #{$breakpoint-lg-max} {
    //     margin: 2rem;
    //   }
    //   .requirements{
    //     color: rgb(199, 198, 198);
    //   }
    // }
    .filters {
      display: flex;
      justify-content: space-between;
      gap: 20px;
      margin: auto auto 0;
      color: white;
      z-index: 10;
      max-width: 1000px;
      width: 100%;
      .BaseSelect{
        ::v-deep{
          select{
            max-width: 230px;
          }
        }
      }
      @media #{$breakpoint-lg-max} {
        flex-direction: column;
        width: 350px;
        margin: 0 auto 2rem;
      }
    }
  }
  .Login{
    z-index: 10;
  }
  .Requirements{
    z-index: 10;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
